import type { ThreadFilters } from "@productlane/zero/queries"

// A close-loop thread assigned to me already counts under "my", so the
// close-loop share of the total inbox badge leaves mine out.
export const closeLoopNotAssignedTo = (userId: string): ThreadFilters => ({
	assigneeIds: [userId],
	negations: { assigneeIds: true },
})
